import { render, staticRenderFns } from "./ProfilesTable.vue?vue&type=template&id=b6d8505a&"
import script from "./ProfilesTable.vue?vue&type=script&lang=js&"
export * from "./ProfilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports